import styled from 'styled-components';
import { DropdownItem } from 'reactstrap';
import { color } from '@whitelabel/helpers/style/colors';
import {
  BaseStyledDropdownItem,
  BaseStyledDropdownMenu,
  StyledDropdownButton as BaseStyledDropdownButton,
} from '@whitelabel/rentalcover-shared/styled/StyledBaseDropdown';

export const StyledDropdownMenu = BaseStyledDropdownMenu;
export const StyledDropdownItem = BaseStyledDropdownItem;

export const StyledDropdownButton = styled(BaseStyledDropdownButton)`
  font-weight: 400;
`;

export const StyledDropdownItemDivider = styled(DropdownItem).attrs(() => ({ divider: true }))`
  margin: 0 0 0.5rem;
  border-color: ${color('paleGrayBlue')};
`;

export const StyledDropdownItemIcon = styled.svg.attrs(() => ({ 'aria-hidden': 'true' }))`
  display: block;
  margin-inline-end: 0.5rem;
  width: 1rem;
  height: 1rem;

  path[fill] {
    fill: ${color('oliveDrab')};
  }
`;
